export default "__VITE_PUBLIC_ASSET__30107b8f__"